<template>
    <div class="EvalDForm">
        <modal
            name="InfoModal"
            width="80%"
            height="auto"
            :scrollable="true"
            :adaptive="true"
            :clickToClose="true"
            style="overflow:scroll"
            v-show="viewhtml"
        >
            <div class="htmlData" v-if="viewhtml">
                <button type="button" class="close" @click="closeModal">X</button>
                <div v-for="item of this.listHtml" :key="item.id">
                    <div :id="'txt_' + item.id" v-html="item.value" v-if="item.show"/>
                </div>
            </div>
        </modal>
        <div class="titlePage" v-if="formList">
            {{this.titleForm}}
        </div>
        <div class="detailPage" v-html="descForm" v-if="formList" />
        <va-notification v-if="formListNoForm" color="danger" class="refNoData">El formulario solicitado no se encuentra activo.</va-notification>
        <va-notification v-if="formListAdd" color="info" class="refNoData"> 
          Ha finalizado el proceso y se ha guardado su autoevaluación.<br><br>
          Se aplicó para los siguientes periodos académicos: {{ periodsMiss.map(Number).sort((a, b) => a - b).join(', ') }}         
        </va-notification>
        <va-notification v-if="formListsend" color="info" class="refNoData">El formulario solicitado ya se encuentra diligenciado.</va-notification>
        <div class="formPage" v-if="formList">
            <ValidationObserver ref="obsFieldsFiles">
                <FormCharact :FieldsForm="listFormCharact" :ModelForm="listFormCharactModel" :method="executeProcess"  />
            </ValidationObserver>
            <button
                id="loadForm"
                type="submit"
                @click="sendForm"
                class="loginbtn primaryBtn primaryBtn"
            >Evaluar</button>
            <router-link :to="'/admin/AutoEvaluacion/'" class="returnButton">Regresar</router-link>
        </div>
        <div class="formPage" v-else>
            <div class="col-md-12 text-left">
                <button class="loginbtn primaryBtn primaryBtn" type="submit" v-on:click="LinkReload()">
                    <va-icon name="fa fa-arrow-left" size="60" /> Regresar
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import IberoHelpers from '@/store/helpers.js'
import FormCharact from '@/components/forms/Forms.vue'
export default {
  name: 'FormEvalDocente',
  components: {
    FormCharact,
  },
  data () {
    return {
      periodsMiss: [],
      titleForm: '',
      descForm: null,
      // -------------------------
      renderComponent1: false,
      historyPerson: false,
      datForm: [],
      refObject: {},
      // -------------------------
      listFormCharact: [],
      listFormCharactQuestion: [],
      listFormCharactModel: {},
      listHtml: [],
      // -------------------------
      viewhtml: false,
      formList: true,
      formListsend: false,
      formListAdd: false,
      formListAddRestric: false,
      formListNoForm: false,
      titleForm: '',
      // --------------------------
      teacherId: null,
    }
  },
  methods: {
    LinkReload () {
      this.$router.push('/admin/AutoEvaluacion/')
    },
    sendForm () {
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsFiles.validate().then(results => {
          if (!results) {
            IberoHelpers.scrollToTop(0, 0)
            resolve(false)
          } else {
            this.refObject = {}
            let loader = this.$loading.show()
            for (var data in this.listFormCharactModel) {
              if (Array.isArray(this.listFormCharactModel[data])) {
                var coma = ''
                this.refObject[data] = ''
                for (var i = 0; i < this.listFormCharactModel[data].length; i++) {
                  if (this.listFormCharactModel[data][i] !== '') {
                    this.refObject[data] += coma + this.listFormCharactModel[data][i]
                    coma = ', '
                  }
                }
              } else if (data.indexOf('_Add') >= 1 && this.listFormCharactModel[data] !== '') {
                var newId = data.split('_')
                var idRefAdd = this.listFormCharact.findIndex(function (element) {
                  return element.id === data
                })
                if (this.refObject[newId[0] + '_' + newId[1]] === this.listFormCharact[idRefAdd].aditional) {
                  this.refObject[newId[0] + '_' + newId[1]] += ' - ' + this.listFormCharactModel[data]
                }
              } else if (this.listFormCharactModel[data] instanceof Date) {
                this.refObject[data] = IberoHelpers.dataObjDate(this.listFormCharactModel[data])
              } else if (this.listFormCharactModel[data] === true) {
                this.refObject[data] = 'Si'
              } else if (this.listFormCharactModel[data] === false) {
                this.refObject[data] = 'No'
              } else {
                this.refObject[data] = this.listFormCharactModel[data]
              }
            }

            // 100067981
          for(let i = 0; i < this.periodsMiss.length; i++){
            var addAnswer = IberoHelpers.insertFormAnswer(this.$store, this.$session.get('evalDo').form, this.$session.get('IberoJWTAdminLogin').idBanner, this.refObject, this.teacherId, this.periodsMiss[i], this.periodsMiss[i])

            //for(let i = 0; i < this.periodsMiss.length; i++){
              //var addAnswer = IberoHelpers.insertFormAnswer(this.$store, this.$session.get('evalDo').form, 100042692, this.refObject, this.teacherId, this.periodsMiss[i], this.periodsMiss[i])

              addAnswer.then(Response => {
                if (Response) {
                  this.formList = false
                  if (Response.data.message === 'Success') {
                    this.formListAdd = true
                  } else {
                    this.formListAdd = true
                  }
                  IberoHelpers.scrollToTop(0, 0)
                  resolve(true)
                } else {
                  resolve(false)
                }
                loader.hide()
              })
            }
          } 
        })
      })
    },
    setObjectlist (valorum) {
      var DataArray = ''
      var infolist = []
      DataArray = valorum.split('|')
      for (var i = 0; i < DataArray.length; i++) {
        infolist.push(
          { id: DataArray[i], value: DataArray[i] }
        )
      }
      return infolist
    },
    executeHistory () {
      this.$modal.show('HistoryModal')
    },
    loadForm (data) {
      this.listFormCharact.length = 0
      for (var i = 0; i < data.length; i++) {
        var validateRef = ''
        var validatePicker = {}
        var listData = ''
        var refRegis = 'id_' + data[i].Id_Generic_Form_Question
        var Datplaceholder = data[i].Nam_Generic_Form
        if (data[i].Det_Validate_Generic_Form !== '') {
          validateRef = JSON.parse(data[i].Det_Validate_Generic_Form)
        }
        if (data[i].Type_Generic_Form === 'radio' || data[i].Type_Generic_Form === 'Select') {
          listData = this.setObjectlist(data[i].Det_Data_Generic_Form)
          this.listFormCharactModel[refRegis] = ''
        } else if (data[i].Type_Generic_Form === 'datepicker') {
          this.listFormCharactModel[refRegis] = ''
          validatePicker.format = this.$store.state.dateFormat
          validatePicker.disabledDates = {
            to: new Date(1900, 0, 1),
            from: new Date(),
          }
        } else if (data[i].Type_Generic_Form === 'title') {
          this.listFormCharactModel[refRegis] = data[i].Nam_Generic_Form
        } else if (data[i].Type_Generic_Form === 'accepted') {
          Datplaceholder = data[i].Det_Data_Generic_Form
          if (data[i].Sta_Aditional_Generic_Form) {
            this.listHtml.push({ id: 'cbox_' + refRegis, value: data[i].Det_Generic_Form, show: false })
            Datplaceholder = Datplaceholder.replace('[', '<a class="linkTerm">').replace(']', '</a>')
          }
          listData = 'Si'
        } else if (data[i].Type_Generic_Form === 'check') {
          listData = this.setObjectlist(data[i].Det_Data_Generic_Form)
          this.listFormCharactModel[refRegis] = []
        } else {
          this.listFormCharactModel[refRegis] = ''
        }
        this.listFormCharact.push({
          id: refRegis,
          name: data[i].Nam_Generic_Form,
          type: data[i].Type_Generic_Form,
          class: data[i].Det_Data_Generic_Class,
          placeholder: Datplaceholder,
          values: listData,
          model: refRegis,
          validate: validateRef,
          dateTimePickerOptions: validatePicker,
          tooltip: data[i].Det_Generic_Form_Tooltip,
          disabled: false,
        })
        if (data[i].Sta_Aditional_Generic_Form && data[i].Type_Generic_Form === 'radio') {
          var aditional = data[i].Det_Data_Generic_Form.split('=')
          this.listFormCharactModel[refRegis + '_Add'] = ''
          this.listFormCharact.push({
            id: refRegis + '_Add',
            aditional: aditional[0],
            name: aditional[1],
            type: 'inputAdd',
            class: data[i].Det_Data_Generic_Class + ' noShow',
            placeholder: aditional[1],
            values: aditional[0],
            model: refRegis + '_Add',
            validate: { required: false },
          })
        }
        this.formList = true
      }
    },
    closeModal () {
      debugger
      this.viewhtml = false
    },
    executeProcess (event, refer) {
      var infoRef = document.getElementById(event.target.name + '_Add')
      if (infoRef !== null) {
        var listData = this.listFormCharact.find(function (element) {
          return element.id === infoRef.id
        })
        if (event.target.value === infoRef.getAttribute('idvalidate')) {
          document.getElementById('div_' + event.target.name + '_Add').classList.remove('noShow')
          listData.validate.required = true
        } else {
          document.getElementById('div_' + event.target.name + '_Add').classList.add('noShow')
          listData.validate.required = false
        }
      } else {
        var findType = event.target.id.indexOf('cbox_')
        if (findType === 0) {
          this.$modal.hide('InfoModal')
          this.viewhtml = false
          this.listHtml.forEach(element => {
            if (element.id === event.target.id) {
              element.show = true
            } else {
              element.show = false
            }
          })
          this.viewhtml = true
          if (event.target.checked === true) {
            this.$modal.show('InfoModal')
          } else {
            this.listFormCharactModel[event.target.id.replace('cbox_', '')] = ''
          }
        }
      }
    },
    loadPeriodsMissing(){
      var periodSuccess = IberoHelpers.getTeacherPeriod(this.$store, this.$session.get('IberoJWTAdminLogin').idBanner)
     //var periodSuccess = IberoHelpers.getTeacherPeriod(this.$store, 100042692)
      periodSuccess.then(periodSuccessData => {
        for (let i = 0; i < periodSuccessData.data.length; i++) {
          var formSS = IberoHelpers.GetFormSuccess(this.$store, this.$session.get('IberoJWTAdminLogin').idBanner, periodSuccessData.data[i].periodo_actual, periodSuccessData.data[i].periodo_actual)
          //var formSS = IberoHelpers.GetFormSuccess(this.$store, 100042692, periodSuccessData.data[i].periodo_actual, periodSuccessData.data[i].periodo_actual)
          formSS.then(dataFormR => {
            if (dataFormR.data == '') {
              this.periodsMiss.push(periodSuccessData.data[i].periodo_actual)
            }
          });
        }
      });
    }
  },
  created () {

  },
  mounted () {
    this.loadPeriodsMissing();
    let loader = this.$loading.show()
    var formS = IberoHelpers.GetFormSuccess(this.$store, this.$session.get('IberoJWTAdminLogin').idBanner, this.$session.get('evalDo').period, this.$session.get('evalDo').period)
    //var formS = IberoHelpers.GetFormSuccess(this.$store, 100042692, this.$session.get('evalDo').period, this.$session.get('evalDo').period)
    formS.then(dataFormR => {
      if (dataFormR.data) {
        this.formList = false
        this.formListsend = true
      }
      if (!this.formListsend) {
        /* ------------------------------------------------- */
        // var teacherIdData = IberoHelpers.GetIdPersonByIdBanner(this.$store,this.$session.get('evalDo').idbannerteacher)
        // teacherIdData.then(Response =>{
        //     this.teacherId = Response.data[0].Id_Person
        // })
        this.teacherId = this.$session.get('IberoJWTAdminLogin').idBanner 
        //this.teacherId = 100042692
        /* ------------------------------------------------- */
        const datEvalForm = IberoHelpers.getEvalForm(this.$store, this.$session.get('evalDo').role, this.$session.get('evalDo').period.toString().substring(0, 4), this.$session.get('evalDo').formType)
        datEvalForm.then(Response => {
          if (Response.data !== '') {
            this.titleForm = Response.data[0].Nam_Form
            this.descForm = Response.data[0].Det_Form

            if (Response.data.Sta_Update_Form === false && this.historyPerson === false) {
              this.formList = false
              this.formListsend = true
            } else {
              const formQuestion = IberoHelpers.getEvalFormQuestion(this.$store, Response.data[0].Id_Generic_Form)
              formQuestion.then(formQuestionData => {
                let questions = []
                for (let i = 0; i < formQuestionData.data.length; i++) {
                  questions.push(formQuestionData.data[i])
                }
                this.loadForm(questions)
              })
            }
            loader.hide()
          } else {
            this.titleForm = 'Formulario evaluación docente'
            this.formListNoForm = true
            this.formListsend = false
            this.formList = false
          }
        })
      }
    })
    /* ------------------------------------------------- */
    loader.hide()
  },
  beforeUnmount () {
    this.$session.set('evalDo', '')
  },
}
</script>
<style scoped>
    .detailPage{
        text-align: justify;
        font-size: 15px;
    }

    .formPage .titleRefZone{
      color:#d0ab4b;
    }

    .titlePage{
      color: #d0ab4b;
      border-color: #d0ab4b;
      width: 100%;
  }

  .loginbtn primaryBtn{
    color: #fff !important;
    background-color: #d0ab4b !important;
    border-color: #d0ab4b !important;
  }

  .loginbtn primaryBtn:hover{
    color: #222 !important;
    background-color: #fff !important;
    border-color: #d0ab4b !important;
  }

    .detailPage ::v-deep h3{
        font-size: 17px;
        color: #d0ab4b;
        margin-bottom: 15px;
    }
    .detailPage ::v-deep p{
        margin:0;
    }
    .returnButton{
        color: #222;
        border:3px solid  #222;
        box-sizing: border-box;
        cursor: pointer;
        border-radius: 5px;
        margin-top: 30px;
        width: 200px;
        text-align: center;
        margin-left: 10px;
        padding: 10px;
        display: inline-block;
        font-weight: bold;
    }
    ::v-deep textarea{
        resize: none;
    }
    ::v-deep .titleRef{
      color:#000;
      font-weight: 500;
    }
</style>
